import { updateField } from "vuex-map-fields";

const SET_DEPARTMENTS = (state, departments) => {
  state.departments = departments;
};

const SET_TASK_USER_ID = (state, id) => {
  const clone = { ...state.task };
  clone.user_id = id;
  state.task = clone;
};
const SET_CATEGORIES = (state, categories) => {
  state.categories = categories;
};

const SET_ERRORS = (state, errors) => {
  errors.map((error) => error.join(" "));
  state.errors = errors;
};

const RESET_TASK_FORM = (state) => {
  state.task = state.initialTaskForm;
};
const SET_TASK_CUSTOMER_ID = (state, id) => {
  state.task = { ...state.task, customer_id: id };
};
const SET_CATEGORY = (state, category) => {
  state.category = category;
};

const SET_PRODUCT_LABELS = (state, productLabels) => {
  state.productLabels = productLabels;
};

const SET_USERS = (state, users) => {
  state.users = users;
};

const SET_TYPES = (state, types) => {
  state.types = types;
};

const SET_TYPE = (state, type) => {
  state.type = type;
};

const SET_TEMPLATES = (state, templates) => {
  state.templates = templates;
};

const SET_TASK = (state, task) => {
  state.task = task;
};

const SET_TASK_ID = (state, id) => {
  state.task = { ...state.task, id };
};
const SET_TASK_CATEGORY_ID = (state, id) => {
  state.task = { ...state.task, category_id: id };
};

const FILL_TASK_BY_MODEL = (state, taskModel) => {
  const filledTask = { ...state.task };

  filledTask.id = taskModel.id;
  filledTask.date = taskModel.date;
  filledTask.type = taskModel.type;
  filledTask.customer_id = taskModel.customer_id;
  filledTask.description = taskModel.description;
  filledTask.content = taskModel.content;
  filledTask.visible_for_customers = taskModel.visible_for_customers;
  filledTask.priority = taskModel.priority;
  filledTask.status = taskModel.status;
  filledTask.category_id = taskModel.category_id.toString();
  filledTask.instance_id = taskModel.instance_id;
  filledTask.instance_type = taskModel.instance_type;
  filledTask.create_note = true;

  filledTask.assigned_users = taskModel.users.data.map((user) => user.id.toString());
  filledTask.user_id = taskModel.user_id;
  filledTask.assigned_departments = taskModel.departments.data
    .map((department) => department.id.toString());
  filledTask.productLabels = taskModel.product_labels.data.map((label) => label.id.toString());

  state.task = filledTask;
};

const SET_LOADING = (state, value) => {
  state.loading = value;
};

export default {
  FILL_TASK_BY_MODEL,
  SET_TASK_CATEGORY_ID,
  SET_TASK,
  SET_TEMPLATES,
  SET_DEPARTMENTS,
  SET_TASK_ID,
  SET_TYPE,
  SET_TYPES,
  SET_CATEGORY,
  SET_PRODUCT_LABELS,
  SET_ERRORS,
  SET_TASK_CUSTOMER_ID,
  SET_USERS,
  SET_CATEGORIES,
  RESET_TASK_FORM,
  SET_TASK_USER_ID,
  SET_LOADING,
  updateField,
};
